import { useEffect } from "react";
import { TRACKED_SECTIONS, trackSectionView } from "@/lib/analytics";

/**
 * Reports one anonymous section_view per homepage narrative section per session.
 * Renders nothing; observation only starts after hydration.
 */
export function SectionTracking() {
  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          trackSectionView(entry.target.id);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.4 },
    );
    for (const id of TRACKED_SECTIONS) {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    }
    return () => observer.disconnect();
  }, []);

  return null;
}
